<template>
  <div id="payment" v-if="customInfo">
    <img class="header-image" src="../../assets/images/payment/headerBg.png" alt="" />
    <!-- <header></header> -->
    <div class="content">
      <div class="panel order">
        <div class="panelTitle">
          <h3>订单信息</h3>
        </div>
        <div class="panelContent">
          <div class="item">
            <div>名称：</div>
            <div>{{ customInfo.customName }}</div>
          </div>
          <div class="item">
            <div>手机号：</div>
            <div>{{ customInfo.phoneNo }}</div>
          </div>
        </div>
      </div>
      <div class="panel" v-if="isShowPay">
        <div class="panelTitle">
          <h3>支付方式</h3>
        </div>
        <div class="panelContent">
          <div v-if="isShowWechat" class="payType item"  @click="handlePay('wechat')">
            <div>
              <img src="../../assets/images/payment/wx.png" />微信支付
            </div>
            <CheckBox :isChecked="currentindex === 'wechat'" />
          </div>
          <div v-if="isShowAlipay" class="payType item"  @click="handlePay('alipay')">
            <div>
              <img src="../../assets/images/payment/zfb.png" />支付宝支付
            </div>
            <CheckBox :isChecked="currentindex === 'alipay'" />
          </div>
          <div class="payType item"  @click="handlePay('bank')">
            <div>
              <img src="../../assets/images/payment/bank.png" />对公转账
            </div>
            <CheckBox :isChecked="currentindex === 'bank'" />
          </div>
        </div>
      </div>

      <div class="panel" v-if="!isShowCompanyAccount">
        <div class="panelTitle">
          <h3>支付金额</h3>
        </div>
        <div class="panelContent ">
          <div class="item">
            <div class="payInput">
              <span>￥</span> <input v-model="toRealPay" pattern="[0-9\.]*" @keyup="toRealPay = checkInputs(toRealPay)"
                type="text" />
            </div>
          </div>
        </div>
      </div>

      <div class="panel companyAccount" v-if="isShowCompanyAccount">
        <div class="panelTitle">
          <h3>对公转账账户</h3>
        </div>
        <div class="panelContent">
          <div class="item">
            <div>公司名称</div>
            <div>{{ customInfo.accountInfo.companyName }}</div>
          </div>

          <div class="item">
            <div>银行账号</div>
            <div>{{ customInfo.accountInfo.bankAccount }}</div>
          </div>

          <div class="item">
            <div>开户行</div>
            <div>{{ customInfo.accountInfo.bankName }}</div>
          </div>
        </div>
      </div>

      <div class="panel" v-if="isShowCompanyAccount">
        <div class="panelContent">
          <div class="formItem">
            <div class="label">支付金额：</div>
            <div class="inputWrapper">
              <input type="text" value="" pattern="[0-9\.]*" v-model="payAmount" @keyup="payAmount = checkInputs(payAmount)" placeholder="请填写金额" />
              <label>元</label>
            </div>
          </div>

          <div class="formItem">
            <div class="label">支付时间：</div>
            <div class="inputWrapper">
              <input type="text" readonly v-model="payTime" placeholder="请选择" @click="selectDate" />
            </div>
          </div>

          <div v-if="false" class="formItem">
            <div class="label">支付流水：</div>
            <div class="inputWrapper">
              <input type="text" v-model="serialNo" placeholder="请输入支付流水编号" />
            </div>
          </div>

          <div class="formItem uploadItem">
            <div class="label">凭证上传：<span>最多上传9张</span></div>
            <div class="uploadWrapper">
              <UploadPic @getCheageDelete="getCheageDelete" />
            </div>
          </div>

          <div class="formItem">
            <div class="label">支付备注：</div>
            <div class="inputWrapper textareaWrapper">
              <textarea v-model="remark"> </textarea>
            </div>
          </div>
        </div>
      </div>

      <div class="copyright">Copyright 上海松鼠云上人工智能科技有限公司</div>
      <div v-if="isShowPay" class="footer" v-throttle @click="handleSubmit">
        <button>提交</button>
      </div>
    </div>

    <DatePicker @setDialogVisible='setDialogVisible' :propsShow="isDatePickerShow" @setDate="setDate" />
  </div>
</template>
<script>
import { Toast } from "vant";
import { formatPrice, checkInput } from '../../util/util';
import {
  getWxCodeData,
  getOpenIdUrl,
  getPayResult,
  queryPayCustomInfo,
  queryCompanyPayInfo,
  depositPay,
  useAlipay
} from "../../api/payment";
import CheckBox from "../../components/Checkbox/index.vue";
import DatePicker from "../../components/DatePicker/index.vue";
import UploadPic from "../../components/UploadPic/index.vue";
export default {
  name: "EndLoading",
  props: [],
  components: {
    CheckBox,
    DatePicker,
    UploadPic,
  },
  data () {
    return {
      toPay: 0, //待支付金额
      toRealPay: 0,//真实支付金额
      order: null,
      currentindex: '',
      isDatePickerShow: false, //是否显示日期选择框
      imagesList: [], //对公上传的图片
      orderNo: "",
      sn: "",
      code: 0, //微信支付用到的code
      isShowCompanyAccount: false,
      payMethodJSAPI: "extend_wechat_jsapi",
      payMethodBank: "bank_pay",
      weChatParameter: null, //支付相关的参数
      openId: "",
      tradeSn: "", //交易序列号
      isShowPay: true, //是否显示支付
      payTime: "", //  支付时间
      payAmount: '', // 对公支付金额
      serialNo: "", //流水编号
      remark: "", //备注
      customInfo:'',//客户信息
      customGuid: "", //客户Guid
      meetingNo:'',  //会议编号
      source:'',  //来源
      companyInfo: '',
      isShowWechat: false,
      isShowAlipay: false,
      // 支付宝
      aliPayCode: '',
      // 微信H5
      weChatCodeH5: '',
      // 微信原生
      weChatJsApi: ''
    };
  },
  watch: {},
  computed: {},
  filters: {
    formatPrice: function (price) {
      return formatPrice(price)
    },
  },
  mounted () {
    this.customGuid = this.$route.params.invitedUserId || "";
    this.meetingNo = this.$route.params.meetingNo || "";
    this.source = this.$route.params.source || "";

    // 获取到code
    if (process.env.VUE_APP_ENV === 'development') {
      this.code = 2222
    } else {
      this.code = this.$route.query.code
    }

    if (this.isWeChat() && !this.code) {
      //如果找不到则进行跳转
      this.getWxCodeData();
      return;
    }

    if (this.isWeChat()) {
      this.isShowWechat = true;
      this.isShowAlipay = false;
      this.currentindex = 'wechat';
    } else if (this.isAlipay()) {
      this.isShowWechat = false;
      this.isShowAlipay = true;
      this.currentindex = 'alipay';
    } else {
      this.isShowWechat = false;
      this.isShowAlipay = true;
      this.currentindex = 'wechat';
    }
    this.queryPayCustomInfo();
  },
  created () { },
  methods: {
    checkInputs (price) {
      return formatPrice(checkInput(price))
    },
    //  设置日期
    setDate (date) {
      this.payTime = `${date.year}-${date.month}-${date.day}`
      this.isDatePickerShow = false
    },
    // 手动录入流水
    async addOrderSerial () {
      try {
        let signature = 0;
        // this.payAmount = parseFloat(this.payAmount)
        this.payAmount = parseFloat(this.payAmount.replace(/,/g, ''))
        if (isNaN(this.payAmount)) {
          this.payAmount = 0;
        }
        console.log('this.payAmount', this.payAmount);
        if (this.payAmount <= 0) {
          Toast('支付金额要大于0')
          this.payAmount = formatPrice(this.payAmount)
          return
        }

        let payAmount = this.payAmount

        if (!this.payTime) {
          Toast('支付时间不能为空')
          this.payAmount = formatPrice(this.payAmount)
          return
        }

        if (this.imagesList.length == 0) {
          Toast('支付凭证不能为空')
          this.payAmount = formatPrice(this.payAmount)
          return
        }
        let remark = this.remark.trim()
        if (remark.length > 50) {
          Toast('支付备注不大于50字')
          this.payAmount = formatPrice(this.payAmount)
          return
        }

        const postData = {
          payMethod:"bank_pay",
          openId: this.openId,
          outTradeNo: this.customGuid,
          payTime: this.payTime,
          amount: this.payAmount,
          remark: this.remark,
          files: this.imagesList,
          timespan: this.timespan,
          meetingNo: this.meetingNo,
          signature,
        };
        let { status, result, info } = await depositPay(postData);
        if (status != 0) {
          Toast(info);
          return;
        }
        Toast("添加成功！");
        let ua = navigator.userAgent.toLowerCase();
        let source = this.source
        if (ua.match(/MicroMessenger/i) == "micromessenger") { // 微信内部
          wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              setTimeout(function(){
                if( source == 'alreadyRegistration'){
                  wx.miniProgram.navigateTo({ url: `/pages/customer/alreadyRegistration/index`});
                } else {
                  wx.miniProgram.navigateTo({ url: `/pages/customer/signCode/index`});
                }
              },1000)
            } else {
              setTimeout(function(){
                location.reload()// 刷新当前页面
              },1000)
            }
          })
        }
      } catch (error) {
        Toast(error);
      }
    },
    // 重新加载页面
    reloadPage () {
      setTimeout(() => {
        let href = location.protocol + "//" + location.host + location.pathname
        location.href = href
      }, 1000);
    },
    // 查询客户信息
    async queryPayCustomInfo () {
      try {
        const postData = {
          customGuid: this.customGuid,
          meetingNo: this.meetingNo,
        };
        let { status, result, info } = await queryPayCustomInfo(postData);
        if (status != 0) {
          Toast(info);
          return;
        }
        this.customInfo = result;
        const { aliPayCode, weChatCode, weChatJsApi } = this.customInfo.accountInfo;
        this.aliPayCode = aliPayCode;
        this.weChatCodeH5 = weChatCode;
        this.weChatJsApi = weChatJsApi;
        // this.payAmount = this.toRealPay = this.toPay = (this.order.orderAmount - this.order.receiveAmount).toFixed(2);
        // this.toPay = 0;
        // if (this.toPay <= 0) {
        //   this.isShowPay = false;
        // }
      } catch (error) {
        Toast(error);
      }
    },
    // 获取微信code
    async getWxCodeData () {
      try {
        let redirectUrl = encodeURIComponent(location.href);
        let state = "pad_dl_evalution";
        const postData = {
          redirectUrl,
          state,
        };
        let { status, result, info } = await getWxCodeData(postData);
        if (status != 0) {
          Toast(info);
          return;
        }
        location.href = result;
      } catch (error) {
        console.error(error, "error getWxCodeData");
        Toast(error);
      }
    },
    // 获取用户的openId
    async getOpenIdUrl () {
      try {
        const postData = {
          code: this.code,
        };
        let { status, result, info } = await getOpenIdUrl(postData);
        if (status != 0) {
          Toast(info);
          return;
        }
        this.openId = result;
        console.log(result, "getOpenIdUrl");
        this.depositPay(this.weChatJsApi);
      } catch (error) {
        console.error(error, "error getOpenIdUrl");
        Toast(error);
      }
    },
    // 调用微信支付
    async depositPay (payMethod) {
      try {
        let amount = this.toRealPay
        let returnUrl = location.href;
        let outTradeNo = this.customGuid;
        let openid = this.openId;
        let meetingNo = this.meetingNo;
        const postData = {
          amount,
          returnUrl,
          payMethod,
          outTradeNo,
          openid,
          meetingNo,
        };
        let { status, result, info } = await depositPay(postData);

        console.log(result, "depositPay");
        if (status != 0) {
          Toast(info);
          return;
        }
        let { tradeSn, payRes } = result;

        this.tradeSn = tradeSn;
        this.weChatParameter = {
          //微信搭桥需要的数据
          appId: payRes.appId,
          timeStamp: payRes.timeStamp,
          nonceStr: payRes.nonceStr,
          package: payRes.package,
          signType: payRes.signType,
          paySign: payRes.paySign,
        };
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              () => {
                this.onBridgeReady();
              },
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", () => {
              this.onBridgeReady();
            });
            document.attachEvent("onWeixinJSBridgeReady", () => {
              this.onBridgeReady();
            });
          }
        } else {
          this.onBridgeReady();
        }
      } catch (error) {
        console.error(error, "depositPay");
        Toast(error);
      }
    },
    //获取支付结果
    async getPayResult () {
      Toast.clear()
      // 自定义加载图标
      Toast.loading({
        message: '支付状态查询中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
      try {
        const postData = {
          sn: this.tradeSn
        };
        let { status, result, info } = await getPayResult(postData);
        if (status != 0) {
          Toast(info);
          return;
        }
        if (result) {
          Toast.clear()
          Toast.success('支付成功')
          this.reloadPage()
        } else {
          setTimeout(() => {
            this.getPayResult()
          }, 1000);
        }
      } catch (error) {
        console.error(error, "error getPayResult");
        Toast(error);
      }
    },
    //微信内置浏览器类
    onBridgeReady () {
      var that = this;
      var timestamp = Math.round(that.weChatParameter.timeStamp).toString();
      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          debug: false,
          appId: that.weChatParameter.appId, //公众号名称，由商户传入
          timeStamp: timestamp, //时间戳，自1970年以来的秒数
          nonceStr: that.weChatParameter.nonceStr, //随机串
          package: that.weChatParameter.package,
          signType: that.weChatParameter.signType, //微信签名方式：
          paySign: that.weChatParameter.paySign, //微信签名
          jsApiList: ["chooseWXPay"],
        },
        function (res) {
          console.log(res, "支付返回结果");
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            //支付成功后的操作
            // that.isDisabledSubmitBtn = true;
            // Toast("支付成功");

            that.getPayResult()
            // 重新刷新订单信息
            // that.queryPayInfo();

            //支付成功
            // that.getMyOrder();//请求成功后重新请求订单数据
          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            //取消支付的操作
            // that.isDisabledSubmitBtn = false //按钮恢复高亮
            //  that.redirectPage();//重定向获取新的code
            Toast("取消支付");
            that.reloadPage()

            //取消支付
          } else {
            //支付失败
            // that.isDisabledSubmitBtn = false //按钮恢复高亮
            Toast("支付失败,请重试");
            that.reloadPage()
            //  that.redirectPage();//重定向获取新的code
          }
        }
      );
    },
    //  外部浏览器唤想微信支付
    async externalViewerPay () {
      axios.get('/api/wxpay', {params: {amount: this.amount, notifyUrl: this.notifyUrl}})
        .then(res => {
          const payInfo = res.data; // 后端返回的支付参数
          // 调用微信JS-SDK库的支付接口
          wx.chooseWXPay({
            appId: payInfo.appId,
            timestamp: payInfo.timestamp,
            nonceStr: payInfo.nonceStr,
            package: payInfo.package,
            signType: payInfo.signType,
            paySign: payInfo.paySign,
            success: function (res) {
              // 支付成功后的回调函数
              console.log('支付成功', res);
            },
            fail: function (res) {
              // 支付失败后的回调函数
              console.log('支付失败', res);
            }
          });
        })
        .catch(err => {
          console.error(err);
        });
    },
    selectDate () {
      this.isDatePickerShow = true;
    },
    setDialogVisible (isVisible) {
      this.isDatePickerShow = isVisible;
    },
    // 切换支付方式
    handlePay (payWay) {
      this.currentindex = payWay;
      if (payWay == 'wechat') { // 微信支付
        this.isShowCompanyAccount = false;
      } else if (payWay == 'alipay') {
        this.isShowCompanyAccount = false;
      } else if (payWay == 'bank') {
        this.isShowCompanyAccount = true;
      } 
    },
    isWeChat () {
      //判断是否为微信内部登录
      var ua = window.navigator.userAgent.toLowerCase();
      //console.log(ua);
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true; //是微信内部
      } else {
        return false;
      }
    },
    isAlipay() {
      if (/AlipayClient/.test(window.navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    getCheageDelete (images) {
      this.imagesList = images;
      console.log(images);
    },
    // 支付宝或者微信H5支付
    async aliOrWechatH5Pay(payType) {
      try {
        let amount = this.toRealPay
        let source = 20;
        let returnUrl = location.href;
        if ((payType == 'extend_substitute_cloud_alipay_wap' || payType == 'extend_cloud_alipay_wap') && returnUrl.indexOf('alipay.trade.wap.pay.return') > -1) {
          returnUrl = returnUrl.substring(0, returnUrl.indexOf('?'));
        }
        let outTradeNo = this.customGuid;
        let openid = this.openId;
        let orderType = this.orderType;
        let meetingNo = this.meetingNo;
        const postData = {
          amount,
          source,
          returnUrl,
          payMethod: payType,
          outTradeNo,
          openid,
          orderType,
          meetingNo,
        };
        let { status, result, info } = await depositPay(postData);

        console.log(result, "initPayment");
        if (status != 0) {
          Toast(info);
          return;
        } else {
          if (payType == 'extend_cloud_alipay_wap' || payType == 'extend_substitute_cloud_alipay_wap') {
            let { payRes } = result;
            let div = document.querySelector("#payDiv");
            // 如果页面已经存在payDiv，则只要修改payDiv的innerHTML就可以了，否则提交的表单永远是第一个表单。
            if (!div) {
              div = document.createElement('div');
              div.id = "payDiv";
              document.body.appendChild(div);
            }
            div.innerHTML = payRes;
            document.forms[0].submit();
          } else { // 微信
            let { mweb_url } = result.payRes;
            const backUrl = location.href;
            window.location.href = `${mweb_url}&redirect_url=${encodeURIComponent(backUrl)}`;
          }
        }
      } catch (error) {
        console.error(error, "initPayment");
        Toast(error);
      }
    },
    // 提交
    handleSubmit () {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
        wx.miniProgram.getEnv((res) => {
          if (res.miniprogram) {
              console.log('小程序');
              if (this.currentindex == 'bank') { // 对公转账
                this.addOrderSerial()
              } else if (this.currentindex == 'wechat') { // 微信支付
                if(this.toRealPay === 0){
                  Toast("支付金额不能为0");
                  return
                }
                wx.miniProgram.navigateTo({ url: `/pages/customer/payTransferPage/index?meetingNo=${this.meetingNo}&outTradeNo=${this.customGuid}&amount=${this.toRealPay}&payType=wechat&source=${this.source}`});
              }
          } else {
              console.log('非小程序');
              if (this.currentindex == 'wechat') {
                this.getOpenIdUrl();
              } else if (this.currentindex == 'bank') {
                this.addOrderSerial()
              }
          }
        })
      } else if (/AlipayClient/.test(window.navigator.userAgent)) {
        if (this.currentindex == 'bank') { // 对公转账
          this.addOrderSerial()
        } else {
          if(this.toRealPay === 0){
            Toast("支付金额不能为0");
            return
          }
          this.aliOrWechatH5Pay(this.aliPayCode);
        }
      } else{
        console.log('非微信');
        if (this.currentindex == 'wechat') { // 微信支付
          // this.getOpenIdUrl();
          if(this.toRealPay === 0){
            Toast("支付金额不能为0");
            return
          }
          this.aliOrWechatH5Pay(this.weChatCodeH5);
        } else if (this.currentindex == 'alipay') { // 支付宝支付
          if(this.toRealPay === 0){
            Toast("支付金额不能为0");
            return
          }
          this.aliOrWechatH5Pay(this.aliPayCode);
        } else {
          this.addOrderSerial()
        }
      }
    },
  },
};
</script>
<style>
body {
  margin: 0;
  padding: 0;
}
</style>
<style lang="less" scoped>
*:focus {
  outline: none;
}

texarea {
  border: 0;
  outline: none;
  background-color: rgba(0, 0, 0, 0); // 透明背景
}

#payment {
  input {
    outline: none;
  }

  background: #f4f5f6;

  button {
    border: none;
  }

  .header-img {
    display: block;
    width: 100%;
  }

  .header-image {
    display: block;
    width: 100%;
  }

  header {
    width: 750px;
    height: 486px;
    background: url(../../assets/images/payment/headerBg.png) #2363e8;
    background-size: cover;
    z-index: 0;
  }

  .order {
    .panelContent .item.topay {
      font-size: 40px;
      font-weight: border;
    }
  }

  .content {
    position: relative;
    margin-top: -14%;
    z-index: 100;

    .copyright {
      margin: 32px 0;
      text-align: center;
    }
  }

  .companyAccount {
    .panelContent {
      .item {
        div {
          &:first-child {
            flex-shrink: 0;
            width: 5em;
          }

          &:last-child {
            text-align: right;
          }
        }
      }
    }
  }

  .panel {
    margin-left: auto;
    margin-right: auto;
    border-radius: 32px;
    margin-bottom: 16px;
    overflow: hidden;
    width: 718px;
    background: #ffffff;

    .panelTitle {
      height: 106px;
      background: #ffffff;
      overflow: hidden;

      label {
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #cccccc;
        line-height: 28px;
      }

      h3 {
        font-size: 34px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2e3645;
        margin: 48px 0 0 48px;
      }
    }

    .panelContent {
      padding: 38px 48px 48px 64px;
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2e3645;

      .payInput {

        width: 622px;
        height: 104px;
        background: #FFFFFF;
        border-radius: 16px;
        border: 2px solid #E1E1E1;
        display: flex;
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2E3645;
        align-items: center;

        span {
          margin-left: 40px;
          margin-right: 5px;
        }

        input {
          height: 56px;
          line-height: 56px;
          border: none;
        }




      }

      .uploadItem {
        .label {
          display: flex;
          justify-content: space-between;

          span {
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #cccccc;
            line-height: 28px;
          }
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 48px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      .payType {
        border-bottom: 1px solid #e9e9eb;
        display: flex;
        align-items: center;
        padding-bottom: 38px;
        margin-bottom: 38px;

        div {
          display: flex;
          align-items: center;

          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2e3645;
          line-height: 44px;
        }

        img {
          width: 48px;
          margin-right: 24px;
        }
      }

      .formItem {
        margin-bottom: 64px;

        div {
          &.label {
            margin-bottom: 24px;
          }

          &.inputWrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 40px;
            padding-left: 40px;
            background: #ffffff;
            border-radius: 16px;
            border: 2px solid #e1e1e1;

            &.textareaWrapper {
              padding-right: 0;
              padding: 32px 0px 32px 0px;

              textarea {
                border: none;
                width: 90%;
                margin-left: auto;
                margin-right: auto;
                height: 160px;
                overflow: auto;
              }
            }

            input {
              border: none;
              flex-grow: 1;
              height: 100px;
              margin-right: 20px;
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              line-height: 40px;

              &:focus {
                border: none;
              }
            }
          }
        }
      }
    }
  }

  .footer {
    padding-bottom: 100px;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.12);
    text-align: center;

    button {
      width: 540px;
      height: 88px;
      background: linear-gradient(90deg, #588ffe 0%, #2162e7 100%);
      border-radius: 90px;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 88px;
      margin-top: 24px;
    }
  }
}
</style>
